<template>
	<div class="flex w-full justify-center px-8 sm:px-20 py-32 md:py-12">
		<div class="w-full max-w-2xl lg:max-w-4xl text-ihh-slate-gray space-y-6 text-base">
			<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-4xl text-start">Sitemap - Brands</div>
			<div class="space-y-4">
				<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-3xl text-start">Brands</div>
				<ul class="list-disc pl-6">
					<li v-for="brand in brands" :key="brand.name">
						<router-link :to="brand?.hasCategory ? `/categories${brand.url}` : `/brands${brand.url}`" class="link">
							{{ brand.name }}
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
export default {
	name: 'SitemapBrands',
	inject: ['store'],
	data() {
		return {
			brands: [],
		}
	},

	mounted() {
		axios.get(`${this.store.api}/controllers/bigCommerce/brands`).then((response) => {
			this.brands = response.data?.filter((b) => b.bcId !== 28 && b.bcId !== 23)
		})
	},
}
</script>

<style scoped>
.link {
	@apply text-ihh-dark-salmon hover:text-ihh-salmon font-semibold underline;
}
</style>
